angular.module('impactx.search').controller('TenderItemActionsCtrl', [
    'TranslationService',
    '$redirect',
    'ThemeWorldService',
    'panelService',
    '$context',
    'RFXCreateService',
    'ProductViewService',
    TenderItemActionCtrl]);

function TenderItemActionCtrl(TranslationService, $redirect, ThemeWorldService, panelService, $context, RFXCreateService, ProductViewService) {
    var self = this;

    self.trns = {
        addToThemeWorld: TranslationService.get('addToThemeWorld'),
        removeFromThemeWorld: TranslationService.get('removeFromThemeWorld'),
        createRFX: TranslationService.get('createRFX'),
        addToProductView: TranslationService.get('addToProductView'),
        removeFromProductView: TranslationService.get('removeFromProductView')
    };

    self.$onInit = function () {
        self.hasActions = self.tender.canAddToThemeWorld || self.tender.canAddToProductView || self.tender.canRemoveFromThemeWorld || self.tender.showRFXButton || self.tender.canRemoveFromProductView;
    };

    self.addToThemeWorld = function($event) {
        self.tender.canAddToThemeWorld = false;
        self.tender.canRemoveFromThemeWorld = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.addTendersToThemeWorld([self.tender]);
    };

    self.removeFromThemeWorld = function($event) {
        var tenderIds = [];
        self.tender.canAddToThemeWorld = true;
        self.tender.canRemoveFromThemeWorld = false;
        tenderIds.push(self.tender.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ThemeWorldService.removeTendersFromThemeWorld($context.hasActiveThemeWorld.id, tenderIds);
    };

    self.addToProductView = function($event) {
        self.tender.canAddToProductView = false;
        self.tender.canRemoveFromProductView = true;
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.addTendersToProductView([self.tender]);
    };

    self.removeFromProductView = function($event) {
        var tenderIds = [];
        self.tender.canAddToProductView = true;
        self.tender.canRemoveFromProductView = false;
        tenderIds.push(self.tender.id);
        if($event) {
            $event.stopPropagation();
            $event.preventDefault();
        }
        ProductViewService.removeTendersFromProductView($context.hasActiveProductView.id, tenderIds);
    };

    self.createRFX = function(){
        RFXCreateService.createRFX("tender", self.tender.id);
    }
}